import { appendUrlQuery } from '@core/utils'
import { getJti } from '../system'

export const getExportUrl = (url, params, withJti = true) => {
  const fullUrl = appendUrlQuery(url, params)
  const suffix = `jti=${getJti()}`
  if (withJti) {
    return fullUrl.indexOf('?') > -1
      ? fullUrl + `&${suffix}`
      : fullUrl + `?${suffix}`
  }

  return fullUrl
}
